<template>
  <div>
    <div :class="$style.headerSlot" @click="toggleContent">
      <div :class="$style.row">
        <div v-if="selectable" :class="$style.selectionSection">
          <slot name="selection"></slot>
        </div>
        <div :class="$style.actionsSections">
          <slot name="action"></slot>
        </div>
      </div>
      <slot name="header"></slot>
    </div>
    <div v-if="modelValue" class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: Boolean,
  selectable: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const toggleContent = () => {
  emit("update:modelValue", !props.modelValue);
};
</script>

<style module>
.actionsSections {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 4px 16px;
}

.selectionSection {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  padding: 4px 16px;
}
.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.headerSlot {
  cursor: pointer;
  text-align: right;
}

.content {
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
}
</style>
